"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FE_MATERIALS = void 0;
const fe_materials_json_1 = __importDefault(require("../generator/fe_materials.json"));
exports.FE_MATERIALS = fe_materials_json_1.default;
